import React, { useContext } from 'react'
import { Stepper, Step, StepLabel, useTheme, useMediaQuery } from '@mui/material'
import { StepProps } from '@mui/material/Step'
import { StepLabelProps } from '@mui/material/StepLabel'
import { StepperProps } from '@mui/material/Stepper'

import { MultiStepFormContext } from '~shared/components/reactHookForm/MultiStepForm/MultiStepFormContext'
import { useMultiStepFormStepperStyles } from './MultiStepFormStepperStyles'

export interface Props{
  stepperProps?: Omit<StepperProps, 'children'>
  stepProps?: StepProps
  stepLabelProps?: StepLabelProps
}

const MultiStepFormStepper: React.FC<Props> = (props) => {
  const s = useMultiStepFormStepperStyles()
  const { stepLabels, activeStepIndex } = useContext(MultiStepFormContext)
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  return <Stepper
    className={s.stepper}
    activeStep={activeStepIndex}
    {...props.stepperProps}
  >
    {stepLabels.map((stepLabel, i) => {
      return (
        <Step key={i} {...props.stepProps}>
          <StepLabel {...props.stepLabelProps}>{isMobile ? '' : stepLabel}</StepLabel>
        </Step>
      )
    })}
  </Stepper>
}

export default MultiStepFormStepper
